export default {
  data() {
    return {
      prefcode: {
        '01': '北海道'
        ,'02': '青森県'
        ,'03': '岩手県'
        ,'04': '宮城県'
        ,'05': '秋田県'
        ,'06': '山形県'
        ,'07': '福島県'
        ,'08': '茨城県'
        ,'09': '栃木県'
        ,'10': '群馬県'
        ,'11': '埼玉県'
        ,'12': '千葉県'
        ,'13': '東京都'
        ,'14': '神奈川県'
        ,'15': '新潟県'
        ,'16': '富山県'
        ,'17': '石川県'
        ,'18': '福井県'
        ,'19': '山梨県'
        ,'20': '長野県'
        ,'21': '岐阜県'
        ,'22': '静岡県'
        ,'23': '愛知県'
        ,'24': '三重県'
        ,'25': '滋賀県'
        ,'26': '京都府'
        ,'27': '大阪府'
        ,'28': '兵庫県'
        ,'29': '奈良県'
        ,'30': '和歌山県'
        ,'31': '鳥取県'
        ,'32': '島根県'
        ,'33': '岡山県'
        ,'34': '広島県'
        ,'35': '山口県'
        ,'36': '徳島県'
        ,'37': '香川県'
        ,'38': '愛媛県'
        ,'39': '高知県'
        ,'40': '福岡県'
        ,'41': '佐賀県'
        ,'42': '長崎県'
        ,'43': '熊本県'
        ,'44': '大分県'
        ,'45': '宮崎県'
        ,'46': '鹿児島県'
        ,'47': '沖縄県'
      },
      db_orders_1: {
      },
      db_orders_2: {
      },
      db_orders_3: {
      },
      db_orders_4: {
      },
      db_orders_5: {
      },
      db_users_1: {
        "id": "ユーザID", 
        "email": "ユーザメールアドレス", 
        // "email_verified_at": "メール認証", 
        // "email_verify_token": "メール認証トークン", 
        // "email_change_after": "変更したいメール", 
        // "password": "パスワード", 
        // "password_change_token": "パスワード変更用トークン", 
        // "remember_token": "トークン", 
        "user_type": "ユーザ種別", 
        // "input_status": "ユーザ情報入力状況", 
        "nickname": "ハンドルネーム", 
        "last_name": "ユーザ名 （性）", 
        "first_name": "ユーザ名 （名）", 
        "phonetic_last_name": "ユーザ名 フリガナ（姓）", 
        "phonetic_first_name": "ユーザ名 フリガナ（名）", 
        "postal_code": "郵便番号", 
        "region": "都道府県", 
        "address_1": "住所1", 
        "address_2": "住所2", 
        "phone": "電話番号", 
        "gender": "性別", 
        "old": "生年月日（年齢）", 
        "withdrawal_reason": "退会理由", 
        "deleted_at": "退会日", 
        "created_at": "登録日", 
        "updated_at": "更新日", 
        "del_flg": "ユーザステータス", 
      },
      db_users_2: {
        "id": "ユーザID", 
        "email": "ユーザメールアドレス", 
        "user_type": "ユーザ種別", 
        // "nickname": "ハンドルネーム", 
        "legal_person": "法人格", 
        "corp_name": "法人名", 
        "corp_representative": "法人責任者", 
        "corp_postalcode": "法人郵便番号", 
        "corp_address": "法人住所", 
        "corp_phone_number": "法人電話番号", 
        "hp_url": "活動URL（法人・販売）", 
        "blog_url": "販売者・ブログ URL", 
        "store_name": "販売者の屋号", 
        "last_name": "ユーザ名 （性）", 
        "first_name": "ユーザ名 （名）", 
        "phonetic_last_name": "ユーザ名 フリガナ（姓）", 
        "phonetic_first_name": "ユーザ名 フリガナ（名）", 
        "postal_code": "郵便番号", 
        "region": "都道府県", 
        "address_1": "住所1", 
        "address_2": "住所2", 
        "phone": "電話番号", 
        "gender": "性別", 
        "old": "生年月日（年齢）", 
        "slogan": "一言アピール（スタッフ・キャッチコピー）", 
        // "profile": "プロフィール", 
        "Introduction": "かんたんな事業紹介", 
        "promiss": "購入やれた方への約束", 
        "common_products_id": "販売共通情報ID", 
        "maintenance_policy":"整備内容の方針、概要",
        "outer_care":"外側の手入れ",
        "inner_care":"内側の手入れ",
        "internal_adjustment":"内部の調整",
        "treasuring":"整調",
        "sound_adjustment":"整音",
        "tuning":"調律",
        "etc":"その他",
        "about_payment":"お支払いについて",
        "about_shipping_preparation":"出荷の準備について",
        "delivery_date_appointment":"納品日と調律、調整の打合せ",
        "delivery_adjustment_work":"納品と調律、調整作業",
        "response_case_trouble":"万一のトラブルの際の対応について説明",
        "about_areas_sell":"販売できる地域について",
        "explanation_about_area":"地域についての補足説明",
        "about_test_bullet":"試弾について",
        "test_bullet_required":"試弾必須かどうか",
        "explanation_about_test_bullet":"試弾についての補足説明",
        "postage":"送料",
        "explanation_about_piano_installation":"送料とピアノ設置について詳細説明",
        "explanation_about_delivery":"配送について詳細説明",
        "explanation_about_warranty_details":"保証内容について詳細説明",
        "about_return":"返品",
        "about_exchange":"交換",
        "explanation_about_return_exchange":"返品交換について詳細説明",
        "credit_payment":"クレジット払い",
        "whether_pay_installments":"分割払い可否",
        "explanation_about_payment":"お支払いについての補足説明",
        "explanation_about_notes":"注意事項について詳細説明",
        "identification_flg": "本人確認ステータス", 
        // "parent_users_id": "親ユーザID", 
        "withdrawal_reason": "退会理由", 
        "deleted_at": "退会日", 
        "created_at": "登録日", 
        "updated_at": "更新日", 
        "del_flg": "ユーザステータス", 
      },
      db_users_3: {
        "id": "ユーザID", 
        "email": "ユーザメールアドレス", 
        "user_type": "ユーザ種別", 
        "last_name": "ユーザ名 （性）", 
        "first_name": "ユーザ名 （名）", 
        "phonetic_last_name": "ユーザ名 フリガナ（姓）", 
        "phonetic_first_name": "ユーザ名 フリガナ（名）", 
        "slogan": "一言アピール（スタッフ・キャッチコピー）", 
        "profile": "プロフィール", 
        "parent_users_id": "親ユーザID", 
        "withdrawal_reason": "退会理由", 
        "deleted_at": "退会日", 
        "created_at": "登録日", 
        "updated_at": "更新日", 
        "del_flg": "ユーザステータス", 
      },
    }
  },
  methods: {

    pref_code_to_strring: function (code) {
      if ( this.prefcode[code] ) {
        return this.prefcode[code]
      } else {
        return ""
      }  
    },

    pref_strring_to_code: function (str) {
      if ( Object.keys(this.prefcode).find((key) => this.prefcode[key] === str) == null ) {
        return ""
      } else {
        return Object.keys(this.prefcode).find((key) => this.prefcode[key] === str)
      }
    },

    exchange_db_users: function (str, user_type) {
      // 1:一般　2:販売者　3:スタッフ
      if ( String(user_type) == '1' ) {
        if ( this.db_users_1[str] ) {
          return this.db_users_1[str]
        } else {
          return ""
        }  
      } else if ( String(user_type) == '2' ) {
        if ( this.db_users_2[str] ) {
          return this.db_users_2[str]
        } else {
          return ""
        }  
      } else if ( String(user_type) == '3' ) {
        if ( this.db_users_3[str] ) {
          return this.db_users_3[str]
        } else {
          return ""
        }  
      }
    },

    exchange_db_orders: function (str, type) {
      // 1:一般　2:販売者　3:申請　4:評価　5:評価返答
      if ( String(type) == '1' ) {
        if ( this.db_orders_1[str] ) {
          return this.db_orders_1[str]
        } else {
          return ""
        }  
      } else if ( String(type) == '2' ) {
        if ( this.db_orders_2[str] ) {
          return this.db_orders_2[str]
        } else {
          return ""
        }  
      } else if ( String(type) == '3' ) {
        if ( this.db_orders_3[str] ) {
          return this.db_orders_3[str]
        } else {
          return ""
        }  
      } else if ( String(type) == '4' ) {
        if ( this.db_orders_4[str] ) {
          return this.db_orders_4[str]
        } else {
          return ""
        }  
      } else if ( String(type) == '5' ) {
        if ( this.db_orders_5[str] ) {
          return this.db_orders_5[str]
        } else {
          return ""
        }  
      }
    },

    /*
     * 値がnull、undefined、空の場合指定した初期値に変換
     */
    cinit: function (str, init = "") {
      if (str == null || str == undefined || str == '') {
        return init;
      } else {
        return str;
      }
    },

    /*
     * メッセージ一覧画面にて、メッセージ送信者の名前が長すぎる場合、
     * charAt(length)以降の文字を'...'と交換
     */
    format_title: function (str, length) {
      return str.length > length ? `${str.split('').slice(0, length).join('')}...` : str
    },

    number_format: function (num) {
      return num.toString().replace(
        /(\d+?)(?=(?:\d{3})+$)/g,
        function (x) {
          return x + ',';
        }
      );
    },

    /*
     * メッセージ一覧画面にて、メッセージ送信者の名前が長すぎる場合、
     * charAt(length)以降の文字を'...'と交換
     */
    limit_tags: function (tags, width) {
      const tag_margin = 2, tag_padding = 10, tag_font_size = 16, appending_text = 20
      let limited_tags = [], limited_tags_width = 0, index = 0
      while (limited_tags_width < width && index - 1 < tags.length) {
        index++
        limited_tags_width += tags[index].length * tag_font_size + 2 * (tag_padding + tag_margin)
        limited_tags.push(tags[index])
      }
      if (limited_tags.length < tags.length) {
        limited_tags.push(`...他${tags.length - limited_tags.length}`)
      }
      return limited_tags
    },

    /*
     * メールアドレス形式チェック
     */
    check_mail: function (mail_address) {
      if (!mail_address.match(/[A-Za-z0-9-_.*!#$%&'*+/=?^`{|}~]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/)) {
        return true;
      } else {
        return false;
      }
    },

    /*
     * 現在日時
     */
    now_date_time: function(){
      var now = new Date();
      var Year = now.getFullYear();
      var Month = now.getMonth()+1;
      var Dt = now.getDate();
      var Hour = now.getHours();
      var Min = now.getMinutes();
      Month = ("0" + Month.toString()).slice(-2)
      Dt = ("0" + Dt.toString()).slice(-2)
      Hour = ("0" + Hour.toString()).slice(-2)
      Min = ("0" + Min.toString()).slice(-2)
      //var Sec = now.getSeconds();
      return Year + "年" + Month + "月" + Dt + "日 " + Hour + ":" + Min;
    },

    now_date_time_hyphen: function(){
      var now = new Date();
      var Year = now.getFullYear();
      var Month = now.getMonth()+1;
      var Dt = now.getDate();
      var Hour = now.getHours();
      var Min = now.getMinutes();
      var Sec = now.getSeconds();
      Month = ("0" + Month.toString()).slice(-2)
      Dt = ("0" + Dt.toString()).slice(-2)
      Hour = ("0" + Hour.toString()).slice(-2)
      Min = ("0" + Min.toString()).slice(-2)
      Sec = ("0" + Sec.toString()).slice(-2)
      //var Sec = now.getSeconds();
      return Year + "-" + Month + "-" + Dt + " " + Hour + ":" + Min + ":" + Sec;
    },

    get_nextmonth_date: function (date, months) {
      var months = months || 1;
      var year = date.getFullYear();
      var month = date.getMonth();
      var day = date.getDate();
      var nextDate = new Date(year, month);
      nextDate.setMonth(nextDate.getMonth() + months);
      var lastDay = new Date(nextDate.getFullYear(), nextDate.getMonth() + 1, 0).getDate();
      if(lastDay < day) {
          nextDate.setDate(lastDay);
      } else {
          nextDate.setDate(day);
      }
      return nextDate;
    },

    date_time_format_for_attachment_file: function (datetime) {
      var YYYY = datetime.getFullYear();
      var MM = ('00' + String(datetime.getMonth()+1)).slice( -2 );
      var DD = ('00' + String(datetime.getDate())).slice( -2 );
      var nowdate = new Date();
      var hh = ('00' + String(nowdate.getHours())).slice( -2 );
      var mm = ('00' + String(nowdate.getMinutes())).slice( -2 );
      var ss = ('00' + String(nowdate.getSeconds())).slice( -2 );
      return YYYY + "-" + MM + "-" + DD + " " + hh + ":" + mm + ":" + ss;
    },

    /*
     * 時間フォーマット
     */
    date_time_format: function (datetime) {
      if (datetime != undefined && datetime != "") {
        let d, t;
        d = datetime.split(" ")[0];
        t = datetime.split(" ")[1];
        return d.split("-")[0] + "年" + d.split("-")[1] + "月" + d.split("-")[2] + "日" + " " + t.split(":")[0] + "時" + t.split(":")[1] + "分"
      }
      return datetime;
    },

    date_time_format_for_message: function (datetime) {
      if (datetime != undefined && datetime != "") {
        let d, t;
        d = datetime.split(" ")[0];
        t = datetime.split(" ")[1];
        return d.split("-")[1] + "/" + d.split("-")[2] + " " + t.split(":")[0] + ":" + t.split(":")[1];
      }
      return datetime;
    },

    date_only_format: function (datetime) {
      if (datetime != undefined && datetime != "") {
        let d;
        d = datetime.split(" ")[0];
        return d.split("-")[0] + "年" + d.split("-")[1] + "月" + d.split("-")[2].split("T")[0] + "日"
      }
      return datetime;
    },

    date_format: function (datetime) {
      if (datetime != undefined && datetime != "") {
        let d = datetime;
        return d.split("-")[0] + "年" + d.split("-")[1] + "月" + d.split("-")[2] + "日"
      }
      return datetime;
    },

    date_only_format_for_mypage: function (datetime) {
      if (datetime != undefined && datetime != "") {
        let d;
        if ( datetime.indexOf('T') != -1 ) {
          d = datetime.split("T")[0];
        } else {
          d = datetime.split(" ")[0];
        }
        return d.split("-")[0] + "/" + d.split("-")[1] + "/" + d.split("-")[2]
      }
      return datetime;
    },

    getUserName: function (hash) {
      let name = "";
      if ( hash['last_name'] != null && hash['first_name'] != null ) {
        name = hash['last_name'] + ' ' + hash['first_name'];
      } else {
        name = hash['nickname'];
      }
      return name;
    },

    time_only_format_for_message: function (datetime) {
      if (datetime != undefined && datetime != "") {
        let t;
        t = datetime.split(" ")[1];
        return t.split(":")[0] + ":" + t.split(":")[1];
      }
      return datetime;
    },

    convert_jst_for_message: function (datetime) {
      if (datetime != undefined && datetime != "" && datetime.indexOf("T") != -1) {
        let time = new Date(datetime);
        //time.setHours(time.getHours() + 9);
        return time.toLocaleString();
      }
      return datetime;
    },

    create_multi_param: function (searchValue, redirect_url, val_name) {
      let arr = [];
      for (let key in searchValue) {
        if (searchValue[key]){
          arr.push(key);
        }
      }
      if ( arr.length > 0 ) {
        if (redirect_url==''){redirect_url+='?'+val_name+'=';}else{redirect_url+='&'+val_name+'=';}
        redirect_url += arr.join(',');
      }
      return redirect_url
    },

    /*
     * 最終送信メッセージコードを最終送信メッセージに変換
     */
    get_last_send_message_type_str: function(code){
      if ( code in this.last_send_message_types ) {
        return this.last_send_message_types[code];
      } else {
        return '';
      }
    },

    get_hash_value: function(hash, value) {
      for (let h of hash) {
        if ( String(h["no"])==String(value) ) {
          return String(h["name"]);
        }
      }
      return '';
    },

    user_photo_change: function(img) {
      if (img==""||img==null) {
        return "/static/img/icon/user.png";
      } else {
        return img;
      }
    },

    login_check: function(token) {
      if ( token != null && token != '' ) {
        return true;
      } else {
        localStorage.setItem("beforeUrl", location.pathname);
        this.$router.push({path: '/login'});
        return false;
      }
    },

    convert_br: function(str) {
      return String(str).replace(/\r?\n/g, '<br>')
    },

  }
}



// WEBPACK FOOTER //
// ./src/mixins/util.js